import React from "react";
const SimpleProcessSection = () => {
  const steps = [{
    number: "1",
    title: "Cadastro simples e rápido",
    description: "Faça seu cadastro e em até 5 dias úteis terá sua aprovação para acessar nossa plataforma."
  }, {
    number: "2",
    title: "Consulte as taxas de diferentes bancos",
    description: "Acesse nossa plataforma, filtre por maquininha ou clínica e antecipe valores em segundos!"
  }, {
    number: "3",
    title: "Solicite a antecipação e receba no mesmo dia",
    description: "Em 3 cliques você solicita a antecipação e recebe no mesmo dia."
  }];
  return <section className="py-20 bg-drcash-maastricht-blue text-white">
      <div className="container mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-1 bg-drcash-caribbean-green/10 rounded-full text-drcash-caribbean-green text-sm mb-6">
            Processo Descomplicado
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Cadastro imediato</h2>
          <p className="max-w-2xl mx-auto text-gray-300">
            Você pode manter suas maquininhas atuais sem nenhuma integração necessária.
            Em 3 cliques você solicita a antecipação e recebe no mesmo dia.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative">
          {steps.map((step, index) => <div key={index} className="text-center relative z-10">
              <div className="w-16 h-16 bg-drcash-caribbean-green text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6">
                {step.number}
              </div>
              <h3 className="text-xl font-bold mb-4">{step.title}</h3>
              <p className="text-gray-300">{step.description}</p>
            </div>)}
          
          {/* Connecting line */}
          
        </div>
      </div>
    </section>;
};
export default SimpleProcessSection;